import { ACCESS_TOKEN, HTTPS_CODE } from 'common/config/constant';
import { Navigate, useLocation } from 'react-router-dom';
import { StorageServices } from 'utils/storage';
import { AUTH_ROUTES, ROUTES } from './routes';
import { useCheckPermission } from 'hooks/useCheckPermission';

const ProtectedRoute = ({ children, isPrivate }) => {
  const accessToken = StorageServices.getData(ACCESS_TOKEN);
  const location = useLocation();

  if (!useCheckPermission(isPrivate)) {
    return <Navigate to={`/${HTTPS_CODE.forbidden}`} replace />;
  }

  if (!accessToken && !AUTH_ROUTES.includes(location.pathname)) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (location.pathname === ROUTES.LOGIN && accessToken) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return children;
};

export default ProtectedRoute;
